import './vendor/modernizr';

import { Trigger } from './lib/trigger';
import { GAEvents } from './lib/ga-events';

const trigger = new Trigger();
trigger.init();


if ( document.querySelector( '.js-carousel' ) ) {
    // import module for side effects
    import('./lib/carousel').then( module => {
        const carousel = new module.Carousel();
        carousel.init();
    } )
}

//const ga = new GAEvents();
//ga.init();

const eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart"];

const loadJS = () => {

    // Remove event listeners
    eventList.forEach(event => {
        document.removeEventListener(event, loadJS);
    });

    // Get scripts with data-src attribute
    const scripts = document.querySelectorAll('script[data-src]');

    // Loop through scripts and replace with src attribute
    Array.from(scripts).forEach(script => {
        script.src = script.dataset.src;
    });
}

// For each event type, add event listener to window
eventList.forEach(event => {
    window.addEventListener(event, loadJS, {passive: true});
});

if ( 'serviceWorker' in navigator ) {
    window.addEventListener( 'load', () => {
        navigator.serviceWorker.register( '/sw.js' ).then( registration => {
            console.log( 'SW registered: ', registration );
        } ).catch( registrationError => {
            console.log( 'SW registration failed: ', registrationError );
        } );
    } );
}
